/**
 * Maximum number of section ads that can be displayed on an article
 * (applies to both body and slideshow sections)
 */
export const AD_LIMIT_DEFAULT = 15;
export const AD_LIMIT_PAID_CONTENT = 3;

/**
 * Word count threshold to before displaying an ad between body sections.
 * (initial first, default thereafter)
 */
export const BODY_AD_WORD_COUNT_THRESHOLD = 250;
export const BODY_AD_WORD_COUNT_THRESHOLD_INITIAL = 100;

/**
 * Declares the cadence for ads between mobile slideshow sections.
 *
 * i.e.: an ad should be rendered once every 5 non-floating-asset sections, with
 * an initial offset of 2.
 *
 * (If you update these numbers, please update this comment, too!)
 */
export const SLIDESHOW_AD_CADENCE = 5;
export const SLIDESHOW_AD_OFFSET = 2;

/**
 * Number of sections to act as a "buffer" between the first and the last ad.
 *
 * On NON-SPONSORED stories, an ad should not display within N sections of the
 * last section.
 *
 * e.g.: Let's say we set this number to 2. If an article has 8 sections, the
 * first ad should display after the second section, but the second ad should
 * not display after the 7th section because it is within 2 sections of the
 * "bottom" ad.
 */
export const SECTION_AD_BOUNDARY = 2;
